import React from 'react';

interface Props {
  /** Large translucent icon shown as the only content of the empty state. */
  icon: React.ReactNode;
  /** Accessible label for screen readers; not visible. */
  label: string;
}

const EmptyState: React.FC<Props> = ({ icon, label }) => {
  return (
    <div className="wg-empty" role="region" aria-label={label}>
      <span className="wg-empty__watermark" aria-hidden>
        {icon}
      </span>
    </div>
  );
};

export default EmptyState;
